import React, { ImgHTMLAttributes } from 'react'
import { Image } from 'react-bootstrap'
import styles from './styles/generic-components.module.scss'
import { useCountries } from 'hooks/use-countries'
import { getClassicUrl } from 'constants/api'
import FlagMissing from 'images/flags/missing.png'
import { getUnknownDisplayText } from 'utils'
import classNames from 'classnames'

interface Props {
  alpha3?: string
  className?: string
}

export const Flag: React.FC<Props & ImgHTMLAttributes<any>> = ({
  alpha3,
  className = '',
  ...props
}) => {
  const { getAlpha2, getCountryName } = useCountries()
  const alpha2 = getAlpha2(alpha3)
  return (
    <Image
      {...props}
      src={
        alpha2 === getUnknownDisplayText()
          ? FlagMissing
          : `${getClassicUrl()}/Content/Public/Clubspark/itf/global/img/flags/${alpha2}.png`
      }
      className={classNames(styles.flag, className)}
      alt={getCountryName(alpha3)}
      title={getCountryName(alpha3)}
    />
  )
}

export const Country: React.FC<Props> = ({ alpha3, className = '', ...props }) => {
  const { getCountryName } = useCountries()
  return (
    <span {...props} className={className}>
      {getCountryName(alpha3)}
    </span>
  )
}
